module.exports = __webpack_public_path__ + "e8355a1d78e8a5edc5baf285517b2322.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/8.png
// module id = 306
// module chunks = 0